import Vue from 'vue'

Vue.directive('select-dom', {
  inserted: function (el, binding, vnode) {
    el.contentWindow.body.background = '#000'

    el.onclick = function (e) {
      let dom = e.currentTarget
      let src = dom.currentSrc

      var divDom = document.createElement('div')
      divDom.innerHTML = '<div style="display: block;background: #000;z-index: 11; position: fixed;top: 0;left: 0;bottom: 0;right: 0;width: 100%;    margin: 0;padding: 0;">' +
        '<img src="' + src + '" style="max-height: 100vh;max-width: 100vw;display: block;margin: 0 auto;">' +
        '</div>'

      document.getElementsByTagName('body')[0].append(divDom)
    }
  }
})
function addWaterMarker (str, parentNode, font, textColor) {
  // 水印文字，父元素，字体，文字颜色
  var can = document.createElement('canvas')
  parentNode.appendChild(can)
  can.width = 200
  can.height = 150
  can.style.display = 'none'
  var cans = can.getContext('2d')
  cans.rotate((-20 * Math.PI) / 180)
  cans.font = font || '16px Microsoft JhengHei'
  cans.fillStyle = textColor || 'rgba(180, 180, 180, 0.3)'
  cans.textAlign = 'left'
  cans.textBaseline = 'Middle'
  cans.fillText(str, can.width / 10, can.height / 2)
  parentNode.style.backgroundImage = 'url(' + can.toDataURL('image/png') + ')'
}

const waterMarker = {
  bind: function (el, binding) {
    addWaterMarker(binding.value.text, el, binding.value.font, binding.value.textColor)
  }
}
Vue.directive('waterMarker', waterMarker)
